var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_2561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.632 0.6C4.632 0.268629 4.90063 0 5.232 0H13.5538V1.2H5.832V8.72758H4.632V0.6ZM18.768 5.21277C19.0993 5.21277 19.368 5.4814 19.368 5.81277V8.72758C19.368 9.05895 19.0993 9.32758 18.768 9.32758C18.4366 9.32758 18.168 9.05895 18.168 8.72758V5.81277C18.168 5.4814 18.4366 5.21277 18.768 5.21277Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9736 1.86809V5.39293H17.4994L13.9736 1.86809ZM18.5878 6.59293H13.5538C13.1227 6.59293 12.7736 6.2441 12.7736 5.81277V0.780159C12.7736 0.348834 13.1227 0 13.5538 0C13.7129 0 13.8655 0.0631921 13.978 0.175679L19.1922 5.38845C19.3047 5.50098 19.368 5.65361 19.368 5.81277C19.368 6.24412 19.0188 6.59293 18.5878 6.59293Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 10.9996C21.6 11.331 21.3314 11.5996 21 11.5996H20C19.6686 11.5996 19.4 11.331 19.4 10.9996C19.4 10.6682 19.6686 10.3996 20 10.3996H21C21.3314 10.3996 21.6 10.6682 21.6 10.9996Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 10.9996C21.6 11.331 21.3314 11.5996 21 11.5996H19C18.6686 11.5996 18.4 11.331 18.4 10.9996C18.4 10.6682 18.6686 10.3996 19 10.3996H21C21.3314 10.3996 21.6 10.6682 21.6 10.9996Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 12.9996C21.6 13.331 21.3314 13.5996 21 13.5996H20C19.6686 13.5996 19.4 13.331 19.4 12.9996C19.4 12.6682 19.6686 12.3996 20 12.3996H21C21.3314 12.3996 21.6 12.6682 21.6 12.9996Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59997 9.47002C1.82677 9.47002 1.19997 10.0968 1.19997 10.87V16.6286H5.30664V17.8286H0.59997C0.268599 17.8286 -3.05176e-05 17.56 -3.05176e-05 17.2286V10.87C-3.05176e-05 9.43408 1.16403 8.27002 2.59997 8.27002H21.4C22.8359 8.27002 24 9.43408 24 10.87V17.2286C24 17.56 23.7313 17.8286 23.4 17.8286H19.06V16.6286H22.8V10.87C22.8 10.0968 22.1732 9.47002 21.4 9.47002H2.59997Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49042 18.9994C7.49042 18.668 7.75905 18.3994 8.09042 18.3994H15.9095C16.2409 18.3994 16.5095 18.668 16.5095 18.9994C16.5095 19.3308 16.2409 19.5994 15.9095 19.5994H8.09042C7.75905 19.5994 7.49042 19.3308 7.49042 18.9994Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49042 20.9994C7.49042 20.668 7.75905 20.3994 8.09042 20.3994H15.9095C16.2409 20.3994 16.5095 20.668 16.5095 20.9994C16.5095 21.3308 16.2409 21.5994 15.9095 21.5994H8.09042C7.75905 21.5994 7.49042 21.3308 7.49042 20.9994Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5233 16.4843C4.5233 16.1529 4.79193 15.8843 5.1233 15.8843H18.8766C19.208 15.8843 19.4767 16.1529 19.4767 16.4843V23.4002C19.4767 23.7316 19.208 24.0002 18.8766 24.0002H5.1233C4.79193 24.0002 4.5233 23.7316 4.5233 23.4002V16.4843ZM5.7233 17.0843V22.8002H18.2766V17.0843H5.7233Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_2561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.f00d184f0a1d6dc98f5b7d3f3293c330.svg";
export { ForwardRef as ReactComponent };